import React, { useState, useEffect, useRef } from 'react';
import classNames from 'classnames';
import { questionValidation } from '../../functions/Validation';
import QuestionHelp from '../question/QuestionHelp';
import ValidationMessage from '../question/ValidationMessage';
import { tracking } from '../../functions/Tracking';
import { Action } from '../../enums/TrackingActionType';

export default function Dropdown(props: any) {

    const [question, setQuestion] = useState(props.question);
    const [dropdownValue, setDropdownValue] = useState(question.answer);
    const [secondsFocused, setSecondsFocused] = useState(0);
    const timerId = useRef<number>(0);

    var inputClasses = classNames(
        {
            'validation-fail': question.validationFail
        }
    );

    var labelClasses = classNames(
        {
            'validation-fail-lbl': question.validationFail
        }
    );


    useEffect(() => {
        setQuestion(props.question);
        if (props.question.answer) {
            setDropdownValue(props.question.answer);
        }

        document.addEventListener("updateAnswer", function (e) {
            let eventDetails: any = e;
            if (eventDetails.detail.questionID === question.questionSetQuestion.questionID) {
                setDropdownValue(eventDetails.detail.answer);
            }
        });
    }, []);

    useEffect(() => {
        if (secondsFocused === 60) {
            //alert("Too much time has passed");
            //alert(question.questionSetQuestion.text);
        }
    }, [secondsFocused]);

    useEffect(() => {
        question.answer = dropdownValue;
        setQuestion(question);
        props.setIndividualCustomerDetails(question);
        props.showConditionQuestions(question.questionSetQuestion.questionID, dropdownValue);
        props.enableQuestions(question.questionSetQuestion.questionID);
        if (props.questionIdPosition !== undefined) {
            if ((props.questionIdPosition.split('|').length - 1) === 1) {
                let questionIdPositionItems = props.questionIdPosition.split('|');
                let parentID = questionIdPositionItems[0].split('-')[0];
                let childID = questionIdPositionItems[1].split('-')[0];
                let childIndex = questionIdPositionItems[1].split('-')[1];

                props.showConditionalChildren(parentID, dropdownValue, childID, childIndex);
            }

            if ((props.questionIdPosition.split('|').length - 1) === 2) {
                let questionIdPositionItems = props.questionIdPosition.split('|');
                let parentID = questionIdPositionItems[0].split('-')[0];
                let parentChildID = questionIdPositionItems[1].split('-')[0];
                let parentChildIndex = questionIdPositionItems[1].split('-')[1];
                let childID = questionIdPositionItems[2].split('-')[0];
                let childIndex = questionIdPositionItems[2].split('-')[1];

                props.showConditionalChildren(parentID, dropdownValue, parentChildID, parentChildIndex, childID, childIndex);
            }
        }
    }, [dropdownValue]);

    const startTimer = () => {
        timerId.current = window.setInterval(() => {
            setSecondsFocused(prev => prev + 1);
        }, 1000);
    };

    const stopTimer = () => {
        window.clearInterval(timerId.current);
        setSecondsFocused(0);
    };

    const updateAnswer = (e: React.ChangeEvent<HTMLSelectElement>) => {
        setDropdownValue(e.target.value);
    };

    const validateAnswer = () => {
        stopTimer();
        tracking(Action.SAVE_QUESTIONS, question.questionSetQuestion.questionID);
        question.validationFail = !questionValidation(question);

        setQuestion(question);
    };

    return (
        <>
            <div className="question">
                <label className={labelClasses} htmlFor={"valen_" + question.questionSetQuestion.questionID}>{question.questionSetQuestion.text}</label>
                <br />
                <select
                    value={dropdownValue}
                    id={"valen_" + question.questionSetQuestion.questionID}
                    className={inputClasses}
                    onChange={(e) => updateAnswer(e)}
                    onFocus={() => startTimer()}
                    onBlur={() => validateAnswer()}>
                    <option value=""></option>
                    {props.question.answerList.map((item: { value: string; text: string }, index: string) => (
                        <option key={item.value + "_" + index} value={item.value}>{item.text}</option>
                    ))}
                </select>
                {question.questionSetQuestion.helpText !== null && question.questionSetQuestion.helpText !== "" &&
                    <QuestionHelp helpText={question.questionSetQuestion.helpText} questionID={question.questionSetQuestion.questionID} />
                }
                {question.validationFail &&
                    <ValidationMessage question={question} overrideMessage="Please select an option" />}
            </div>
        </>

    );
};